import React from 'react'
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";

import { Signup } from './pages/Authentication/SignUp'
import { SetPassword } from './pages/Authentication/SetPassword'
import { AuthOtp } from "./pages/Authentication/AuthOtp";
import { ResetOtp } from "./pages/ResetPassword/ResetOtp";
import { PasswordChangeCompleted } from "./pages/ResetPassword/PasswordChangeCompleted";
import { SignupCompleted } from "./pages/Authentication/SignupCompleted";
import { Login } from "./pages/Authentication/Login";
import { ForgotPassword } from "./pages/ResetPassword/ForgotPassword";
import { ResetPassword } from "./pages/ResetPassword/ResetPassword";

import ProtectedRoute from './Routes/PrivateRoute';

import { DocumentVerification } from "./pages/VerifyDocuments/DocumentVerification";
import { AddressProofUpload } from "./pages/VerifyDocuments/AddressProofUpload";
import { BusinessLicenseUpload } from "./pages/VerifyDocuments/BusinessLicenseUpload";
import { VerifyDocument } from "./pages/VerifyDocuments/VerifyDocument";

import { ProductPayment } from "./pages/ProductPayment/ProductPayment";

import { SecurityPolicies } from "./pages/Policies/SecurityPolicies";

import { SetupCompleteProfile } from "./pages/AcoountSetup/SetupCompleteProfile";
import { VendorDashboard } from "./pages/AcoountSetup/VendorDashboard";

import { AddProduct } from "./pages/AddProduct/AddProduct";
import { DeliverySetup } from "./pages/AddProduct/DeliverySetup";

import { Dashboard } from "./pages/MainDashboard/Dashboard";

import { AllOrders } from "./pages/Orders/AllOrders";
import { PendingOrder } from "./pages/Orders/PendingOrder";
import { AvailableRiders } from "./pages/Orders/AvailableRiders";
import { PlaceOrder } from "./pages/Orders/PlaceOrder";
import { LiveTracking } from "./pages/Orders/LiveTracking";
import { CompleteOrder } from "./pages/Orders/CompleteOrder";
import { CancelOrder } from "./pages/Orders/CancelOrder";

import { Analytics } from "./pages/Analytics/Analytics";
import { Products } from "./pages/Products/Products";
import { ProductDetails } from "./pages/Products/ProductDetails";
import { UsersProductView } from "./pages/Products/UsersProductView";
import { Profile } from "./pages/UserProfile/Profile";

import useSocketNotifications from "./socketListener";
import WithdrawPage from './pages/withdrawal/WithdrawPage';
import ProfileUpdate from './pages/UserProfile/ProfileUpdate';
import { UpdateLocation } from './pages/AcoountSetup/UpdateLocation';
import StoreInformation from './pages/store/StoreInformation';


function App() {

  useSocketNotifications();

  return (
    <>
      <ToastContainer
        position="top-right"
        autoClose={4000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />

      <Routes>

        {/* Default → redirect to dashboard if logged in */}
        <Route 
          path="/" 
          element={
            <ProtectedRoute>
              <Dashboard />
            </ProtectedRoute>
          } 
        />

        {/* -------- AUTH ROUTES (Not Protected) -------- */}
        <Route path="/signup" element={<Signup />} />
        <Route path="/auth/otp" element={<AuthOtp />} />
        <Route path="/auth/set-password" element={<SetPassword />} />
        <Route path="/signup/completed" element={<SignupCompleted />} />
        <Route path="/auth/login" element={<Login />} />

        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/reset-password/new" element={<ResetPassword />} />
        <Route path="/reset-password/otp" element={<ResetOtp />} />
        <Route path="/reset-password/completed" element={<PasswordChangeCompleted />} />

        {/* -------- PROTECTED ROUTES -------- */}

        {/* Personal Info */}
        <Route 
          path="/store-info" 
          element={
            <ProtectedRoute>
              <StoreInformation />
            </ProtectedRoute>
          } 
        />

        {/* Document Verification */}
        <Route 
          path="/verify" 
          element={
            <ProtectedRoute>
              <DocumentVerification />
            </ProtectedRoute>
          } 
        />
        <Route path="/verify/address-proof" element={<ProtectedRoute><AddressProofUpload /></ProtectedRoute>} />
        <Route path="/update-profile" element={<ProtectedRoute><ProfileUpdate /></ProtectedRoute>} />
        <Route path="/verify/business-license" element={<ProtectedRoute><BusinessLicenseUpload /></ProtectedRoute>} />
        <Route path="/verify/document" element={<ProtectedRoute><VerifyDocument /></ProtectedRoute>} />

        {/* Product Payment */}
        <Route path="/onboarding/product-payment" element={<ProtectedRoute><ProductPayment /></ProtectedRoute>} />

        {/* Policies */}
        <Route path="/onboarding/security" element={<ProtectedRoute><SecurityPolicies /></ProtectedRoute>} />

        {/* Account Setup */}
        <Route path="/setup/complete-profile" element={<ProtectedRoute><SetupCompleteProfile /></ProtectedRoute>} />
        <Route path="/setup/dashboard" element={<ProtectedRoute><VendorDashboard /></ProtectedRoute>} />

        {/* Products */}
        <Route path="/products/new" element={<ProtectedRoute><AddProduct /></ProtectedRoute>} />
        <Route path="/setup/delivery" element={<ProtectedRoute><DeliverySetup /></ProtectedRoute>} />

        {/* Main Dashboard */}
        <Route path="/dashboard" element={<ProtectedRoute><Dashboard /></ProtectedRoute>} />
        <Route path="/withdraw" element={<ProtectedRoute><WithdrawPage /></ProtectedRoute>} />
        <Route path="/update-location" element={<ProtectedRoute><UpdateLocation /></ProtectedRoute>} />

        {/* Orders */}
        <Route path="/orders" element={<ProtectedRoute><AllOrders /></ProtectedRoute>} />
        <Route path="/place-orders" element={<ProtectedRoute><PlaceOrder /></ProtectedRoute>} />
        <Route path="/orders/pending" element={<ProtectedRoute><PendingOrder /></ProtectedRoute>} />
        <Route path="/orders/available-riders" element={<ProtectedRoute><AvailableRiders /></ProtectedRoute>} />
        <Route path="/orders/live-tracking" element={<ProtectedRoute><LiveTracking /></ProtectedRoute>} />
        <Route path="/orders/complete" element={<ProtectedRoute><CompleteOrder /></ProtectedRoute>} />
        <Route path="/orders/cancelled" element={<ProtectedRoute><CancelOrder /></ProtectedRoute>} />

        {/* Analytics */}
        <Route path="/analytics" element={<ProtectedRoute><Analytics /></ProtectedRoute>} />

        {/* Products */}
        <Route path="/products" element={<ProtectedRoute><Products /></ProtectedRoute>} />
        <Route path="/users-products" element={<ProtectedRoute><UsersProductView /></ProtectedRoute>} />
        <Route path="/products/:productId" element={<ProtectedRoute><ProductDetails /></ProtectedRoute>} />

        {/* Profile */}
        <Route path="/profile" element={<ProtectedRoute><Profile /></ProtectedRoute>} />

        {/* Fallback */}
        <Route path="*" element={<Navigate to="/" replace />} />

      </Routes>

    </>
  );
}

export default App;
